import './styles/zones.scss';
import './controllers/zoneController.js';
import './controllers/zonePopoverController.js';
import './controllers/zoneModalController';
import './directives/zoneDirectives.js';
import './services/zoneService.js';
import './zone.consts';
export default 'zone';
